import './lang/en';
import __ from 'lodash';
import 'animate.css';

const swalOptions = {
    title: __('Confirm'),
    text: __('Are you sure?'),
    confirmButtonText: __('Proceed'),
    confirmButtonColor: 'red',
    cancelButtonText: __('Cancel'),
    showCancelButton: true,
    showClass: {
        popup: `
      animate__animated
      animate__fadeInLeftBig
      animate__faster
    `
    },
    hideClass: {
        popup: `
      animate__animated
      animate__fadeOutRightBig
      animate__faster
    `
    },
};

export default swalOptions;
